// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ConnectorPathStyle {
  Orthogonal = 0,
  Curved = 1,
  Straight = 2
}
